import { useResetAtom } from 'jotai/utils';
import {
    dataForPropertySubmitStore,
    deliveryETAStore,
    resultsTableEditedStore,
    resultsTableFiltersStore,
    supportRequestAddressTypeStore,
    supportRequestOriginalFileStore,
    supportTableTagIdStore,
} from 'features/my-zone/support-requests/store/property-store';
import { useCallback } from 'react';

export const useResetSupportState = () => {
    const resetSupportTableTagId = useResetAtom(supportTableTagIdStore);
    const resetDeliveryETAStore = useResetAtom(deliveryETAStore);
    const resetDataForPropertySubmitStore = useResetAtom(dataForPropertySubmitStore);
    const resetSupportRequestOriginalFileStore = useResetAtom(supportRequestOriginalFileStore);
    const resetSupportRequestAddressType = useResetAtom(supportRequestAddressTypeStore);
    const resetResultsTableEdited = useResetAtom(resultsTableEditedStore);
    const resetResultsTableFilters = useResetAtom(resultsTableFiltersStore);

    const resetState = useCallback(() => {
        resetSupportTableTagId();
        resetDeliveryETAStore();
        resetDataForPropertySubmitStore();
        resetSupportRequestOriginalFileStore();
        resetSupportRequestAddressType();
        resetResultsTableEdited();
        resetResultsTableFilters();
    }, [
        resetSupportTableTagId,
        resetDeliveryETAStore,
        resetDataForPropertySubmitStore,
        resetSupportRequestOriginalFileStore,
        resetSupportRequestAddressType,
        resetResultsTableEdited,
        resetResultsTableFilters,
    ]);

    return {
        resetState,
    };
};
